var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2712121270(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.9 30",
    style: {
      enableBackground: "new 0 0 200.9 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 60.3701 116.3158)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 6.2289 66.2611)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.1,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,30h-29.7V0.4h29.7V30z M114.8,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,26h-22.5V4h22.5V26z M118.8,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 0.17 15.984)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8769 9.6281)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,30H0V0.4h29.7V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.6,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 90.5846 166.6725)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.3,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 13.8102 94.6842)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.1,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,30h-29.7V0.4h29.7V30z M171.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.1,26h-22.5V4h22.5V26z M175.8,24.8H196V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 15.1656 40.9762)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.1143 23.7345)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,30H28.3V0.4h29.7V30z M29.5,28.9h27.5V1.5H29.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,26H32.2V4h22.5V26z M33.4,24.8h20.2V5.1H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 30.3061 66.21)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.3145 37.9801)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30H56.9V0.4h29.7V30z M58.1,28.9h27.5V1.5H58.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,26H60.8V4h22.5V26z M62,24.8h20.2V5.1H62V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 45.3017 91.2023)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.8,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 2.4481 52.0865)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,30H85.2V0.4H115V30z M86.4,28.9h27.5V1.5H86.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,26H89.2V4h22.5V26z M90.3,24.8h20.2V5.1H90.3V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 75.4437 141.4382)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 10.0104 80.4384)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,30h-29.7V0.4h29.7V30z M143.3,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,26h-22.5V4h22.5V26z M147.2,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,28.5l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1 C172.2,28.4,172,28.5,171.8,28.5z M175.4,21.4l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1C175.8,21.2,175.6,21.4,175.4,21.4z M178.9,14.2l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1C179.3,14.1,179.1,14.2,178.9,14.2z M182.5,7.1L182.2,7 c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1C182.9,7,182.7,7.1,182.5,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,29.6c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l2.1,4c0.1,0.3,0,0.6-0.2,0.8 L200.3,29.6z M196.6,22.5c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l2.1,4 c0.1,0.3,0,0.6-0.2,0.8L196.6,22.5z M192.9,15.5c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2 l2.1,4c0.1,0.3,0,0.6-0.2,0.8L192.9,15.5z M189.2,8.4c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2 l2.1,4c0.1,0.3,0,0.6-0.2,0.8L189.2,8.4z M185.6,1.3c-0.2,0-0.4-0.1-0.5-0.3L185,0.8c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2 l0.1,0.2c0.1,0.3,0,0.6-0.2,0.8L185.6,1.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2712121270);
export default __webpack_public_path__ + "static/media/AK2_7_1212127_0.b4413e8148aa49cdb57fb8e396f48527.svg";
export { ForwardRef as ReactComponent };